/**
 * @generated SignedSource<<9c3fba9ab2083e114ec6a78c7447bd4c>>
 * @relayHash e2382e54faefb52da6b779a5a0e4e131
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46083f55348a2768eb4c27f76700156905d8719d60931948117bb501219e68bd

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PageTreeChildrenQuery$variables = {
  after?: string | null | undefined;
  contentId: string;
  first?: number | null | undefined;
  isSuperAdmin: boolean;
  statuses?: ReadonlyArray<PTGraphQLPageStatus | null | undefined> | null | undefined;
};
export type PageTreeChildrenQuery$data = {
  readonly ptpage: {
    readonly blank: boolean | null | undefined;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
        readonly version: {
          readonly number: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly status: PTGraphQLPageStatus | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type PageTreeChildrenQuery = {
  response: PageTreeChildrenQuery$data;
  variables: PageTreeChildrenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statuses"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "kind": "ScalarField",
  "name": "status"
},
v8 = {
  "kind": "ScalarField",
  "name": "blank"
},
v9 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v10 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "subType"
},
v13 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v15 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "statuses"
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreeChildrenQuery",
    "selections": (v15/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreeChildrenQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "e2382e54faefb52da6b779a5a0e4e131",
    "id": "46083f55348a2768eb4c27f76700156905d8719d60931948117bb501219e68bd",
    "metadata": {},
    "name": "PageTreeChildrenQuery",
    "operationKind": "query",
    "text": "query PageTreeChildrenQuery($contentId:ID!,$statuses:[PTGraphQLPageStatus],$first:Int,$after:String,$isSuperAdmin:Boolean!){ptpage(id:$contentId,status:$statuses){id,title,status,blank,hasChildren,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},children(first:$first,after:$after){nodes{id,title,status,blank,hasChildren,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}}}"
  }
};
})();

(node as any).hash = "7f4eadf7c16e9b339dd6bec11ab87380";

export default node;
